import React from 'react';
import { StyledFooter, StyledContainer, StyledLinks, StyledLink, StyledPartners } from './Footer.styled';
import { Text } from '../../mo-gel';
import { ReactComponent as BtiLogo } from '../../images/footer/BTI_logo_2020_white.svg';
import MovemberFundedLogo from '../../images/footer/movember-funded-logo-white.png';
import { footerNavLinks } from '../../routes';

export const Footer: React.FC = () => {
  return (
    <StyledFooter>
      <StyledContainer>
        <StyledLinks>
          {footerNavLinks.map((link) => (
            <StyledLink key={link.link} to={link.link}>
              <Text tag="p" level="normal" marginTop="0" marginBottom="0" fontWeight="bold">
                {link.title}
              </Text>
            </StyledLink>
          ))}
        </StyledLinks>
        <StyledPartners>
          <BtiLogo />
          <img src={MovemberFundedLogo} alt="Movember Logo" />
        </StyledPartners>
      </StyledContainer>
      <Text tag="p" level="xxSmall" marginTop="0" marginBottom="0" align="center">
        © 2021 Movember. All rights reserved. Movember Canada is a registered charity number 84821 5604 RR0001
      </Text>
    </StyledFooter>
  );
};
